import type { Locale } from '@change-corgi/config/locales';

import type { useAutocompleteServiceLegacy } from '#src/app/shared/hooks/googlePlaces';

type AutocompleteService = Exclude<ReturnType<typeof useAutocompleteServiceLegacy>, undefined>;
export type GooglePlace = { name: string; id: string };

export async function getGooglePlaces(
	{ text, language }: { text: string; language: Locale },
	autocompleteService: AutocompleteService | undefined,
): Promise<GooglePlace[]> {
	if (!autocompleteService || text === '') {
		return [];
	}

	const results = await autocompleteService.getPlacePredictions({
		types: ['administrative_area_level_1', 'administrative_area_level_2', 'locality', 'neighborhood', 'sublocality'],
		input: text,
		language,
	});

	return results.predictions.map((prediction) => ({
		name: prediction.description,
		id: prediction.place_id,
	}));
}
